var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsSectionThreeArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 487,
    viewBox: "0 0 244 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.87 35.32L243.55 0L35.3697 208.18L35.3203 208.13L0.000326813 243.45L0.0497468 243.5L0 243.55L35.3199 278.869L35.3697 278.82L243.55 487L278.87 451.68L70.6896 243.5L278.87 35.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsSectionThreeArrow);
export default __webpack_public_path__ + "static/media/about-us-section-three-arrow.2be2e95b92a589cb59d895baddbbf4c3.svg";
export { ForwardRef as ReactComponent };